<div>
  <div>

    <div class="err-pg-row">
      <h1 style="text-align: center;"> Login required </h1>
    </div>

    <div class="err-pg-row">
      <h2 style="text-align: center;"> In order to proceed, please log in. Continue as: </h2>
    </div>

    <div class="err-pg-row">

      <div class="err-page-button-container">
        <button class="btn btn-primary err-page-btn-primary" (click)="goToProducerAuthPage()"> Producer </button>
        <button class="btn btn-primary err-page-btn-primary" (click)="goToProposedInsuredAuthPage()"> Proposed Insured </button>
      </div>

    </div>

  </div>
</div>
